import { VENDOR_LOGIN, VENDOR_LOGIN_SUCCESS, VENDOR_LOGIN_ERROR, VENDOR_LOGIN_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const VendorLogin = (state = initialState, action) => {
  switch (action.type) {
    case VENDOR_LOGIN:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case VENDOR_LOGIN_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case VENDOR_LOGIN_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case VENDOR_LOGIN_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default VendorLogin;
